export default {
  footer: {
    title: "Best. Mortgage. Rate. Period.",
    legalstatement:
      "Nesto Inc. is registered in Canada. Mortgage Brokers working on the platform are all licensed in the provinces they operate in. Mortgage Brokers are not employed by Nesto, and do not receive remuneration from Nesto for providing their services to customers. Nesto is not endorsed, sponsored, or remunerated by any of the financial institutions present on the website. Nesto does not favor any financial institution in comparing rates for users – rates are ordered from lowest to highest, regardless of the financial institution. The rate comparison tool is not meant to replace advice from mortgage professionals. Nesto encourages users to contact Mortgage Brokers prior to selecting a mortgage product. Nesto.ca, Brokerage #13044 – Nesto.ca is owned and operated by 10319376 Canada Inc."
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/footer.js